module.exports = __webpack_public_path__ + "app/directives/loader.view.html";